import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';

const VideosSection = ({ data, onUpdate }) => {
  const safeData = data || { isVisible: false, videoLinks: [] };
  const [newLink, setNewLink] = useState('');

  const handleToggle = (e) => {
    onUpdate({ ...safeData, isVisible: e.target.checked });
  };

  const handleAddLink = () => {
    const trimmed = newLink.trim();
    if (!trimmed) return;
    const links = Array.isArray(safeData.videoLinks) ? [...safeData.videoLinks, trimmed] : [trimmed];
    onUpdate({ ...safeData, videoLinks: links });
    setNewLink('');
  };

  const handleRemoveLink = (index) => {
    const links = [...(safeData.videoLinks || [])];
    links.splice(index, 1);
    onUpdate({ ...safeData, videoLinks: links });
  };

  const links = Array.isArray(safeData.videoLinks) ? safeData.videoLinks : [];

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Videos Section</h5>
        <Form.Check
          type="checkbox"
          id="videos-visible"
          label="Visible"
          checked={!!safeData.isVisible}
          onChange={handleToggle}
          className="mb-0"
        />
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Video links</Form.Label>
          <div className="d-flex gap-2 mb-2">
            <Form.Control
              type="url"
              value={newLink}
              onChange={(e) => setNewLink(e.target.value)}
              placeholder="Paste video URL (YouTube, Vimeo, etc.)"
              onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddLink())}
            />
            <Button variant="outline-primary" onClick={handleAddLink} type="button">
              Add
            </Button>
          </div>
        </Form.Group>
        {links.length > 0 && (
          <ul className="list-group list-group-flush">
            {links.map((url, index) => (
              <li
                key={`${url}-${index}`}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                <a href={url} target="_blank" rel="noopener noreferrer" className="text-truncate me-2">
                  {url}
                </a>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleRemoveLink(index)}
                  type="button"
                  title="Remove"
                >
                  <i className="bi bi-trash" />
                </Button>
              </li>
            ))}
          </ul>
        )}
      </Card.Body>
    </Card>
  );
};

export default VideosSection;
